<vb-title [title]="'Event_QuestionsAndAnswers_PageTitle' | translate : { '0': webcast.title }"></vb-title>

@if (questions) {
	<div class="webcast-manage-questions-full-screen">
		<webcast-pre-prod-banner [webcast]="webcast">
		</webcast-pre-prod-banner>

		<header class="theme-primary-font-border-fade-50">
			<div class="flex-fill page-title">
				{{ 'Event_QuestionsAndAnswers' | translate }}
			</div>
			<div class="btn-list">
				<!--Buttons to show a list that has been hidden by the user-->
				<button type="button" [hidden]="!isInboxHidden" (click)="isInboxHidden = !isInboxHidden" vbBtnSecondary>
					{{ 'Event_QA_List_Inbox' | translate : { '0': questionCounts.Inbox  } }}
				</button>

				<button type="button" [hidden]="!isQueueHidden" (click)="isQueueHidden = !isQueueHidden" vbBtnSecondary>
					{{ 'Event_QA_List_Queue' | translate : { '0': questionCounts.Queued  } }}
				</button>

				<button type="button" [hidden]="!isClosedHidden" (click)="isClosedHidden = !isClosedHidden" vbBtnSecondary>
					{{ 'Event_QA_List_Closed' | translate : { '0': questionCounts.Closed  } }}
				</button>
			</div>
			<div>
				<form>
					<input #filterInput type="text" name="qTextFilter" class="form-control qtext-filter" [attr.placeholder]="'Event_QA_FilterQuestions' | translate" [attr.aria-label]="'Event_QA_FilterQuestions' | translate" [(ngModel)]="qTextFilter" (ngModelChange)="onQTextFilterChange()">
					<button type="button" [hidden]="!qTextFilter" (click)="qTextFilter=''; onQTextFilterChange(); filterInput.focus()" [attr.aria-label]="'Event_QA_FilterQuestionsReset' | translate" class="qtext-filter-reset">
						<span class="glyphicons remove_2"></span>
					</button>
				</form>
			</div>
		</header>

		<!--Question status list views-->
		<main class="question-list-layout" flex="1">

			<!--Inbox section-->
			<section class="inbox-view theme-primary-font-border-fade-50" [hidden]="isInboxHidden">
				<header class="theme-primary-font-border-fade-50">
					<div class="section-title">
						<div class="flex-fill">
							<div>{{ 'Event_QA_List_Inbox' | translate : { '0': inboxQuestions.length } }}</div>
						</div>
						<div>
							<!--New Questions button for the Inbox (click shows them)-->
							@if (selectedView === Question_View.Inbox && questionCounts.hidden) {
								<button (click)="showNewQuestions()" vbBtnPrimary>
									<span [ngPlural]="questionCounts.hidden">
										<ng-template ngPluralCase="=1">{{ 'Event_QA_IncomingQuestionsCountSingular' | translate: { '0': questionCounts.hidden } }}</ng-template>
										<ng-template ngPluralCase="other">{{ 'Event_QA_IncomingQuestionsCountPlural' | translate: { '0': questionCounts.hidden } }}</ng-template>
									</span>
								</button>
							}
						</div>
						<div>
							<button type="button" [attr.aria-label]="('Remove'  | translate ) + ' ' + ('Event_QA_List_Inbox'  | translate)" class="btn-hide-question-list" (click)="isInboxHidden = !isInboxHidden"><span class="glyphicons remove_2"></span></button>
						</div>
					</div>
				</header>

				<vb-webcast-questions-list [context]="context" [webcast]="webcast" [questions]="inboxQuestions">
				</vb-webcast-questions-list>
			</section>

			<!--Queue section-->
			<section class="queue-view theme-primary-font-border-fade-50" [hidden]="isQueueHidden">
				<header class="theme-primary-font-border-fade-50">
					<div class="section-title">
						<div class="flex-fill">
							<div>{{ 'Event_QA_List_Queue' | translate : { '0': queuedQuestions.length } }}</div>
						</div>
						<div>
							<button type="button" [attr.aria-label]="('Remove'  | translate ) + ' ' + ('Event_QA_List_Queue'  | translate)" class="btn-hide-question-list" (click)="isQueueHidden = !isQueueHidden"><span class="glyphicons remove_2"></span></button>
						</div>
					</div>
				</header>
				<vb-webcast-questions-list [context]="context" [webcast]="webcast" [questions]="queuedQuestions" [allowReordering]="true">
				</vb-webcast-questions-list>

			</section>

			<!--Closed section-->
			<section class="closed-view" [hidden]="isClosedHidden">
				<header class="theme-primary-font-border-fade-50">
					<div class="section-title">
						<div class="flex-fill">
							<div>{{ 'Event_QA_List_Closed' | translate : { '0': closedQuestions.length } }}</div>
						</div>
						<div dropdown vbDropdown class="menu-wrapper">
							<button type="button" id="closedQuestionsFilterBtn" vbBtnSecondary dropdownToggle class="icon-btn">
								<span class="vb-icon vb-icon-sort-by"></span>&nbsp;{{ (closedQuestionsFilterLabel || 'All') | translate }}
							</button>

							<ul *dropdownMenu class="dropdown dropdown-menu dropdown-menu-right" id="closedQuestionsFilterMenu" role="menu" aria-labelledby="closedQuestionsFilterBtn">
								<li>
									<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.All, $event.target.innerText)">
										{{ 'All' | translate }}
									</button>
								</li>
								<li>
									<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.Answered, $event.target.innerText)">
										{{ 'Event_QA_Answered' | translate }}
									</button>
								</li>
								<li>
									<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.Declined, $event.target.innerText)">
										{{ 'Event_QA_Declined' | translate }}
									</button>
								</li>
								<li>
									<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.RepliedDirectly, $event.target.innerText)">
										{{ 'Event_QA_Closed_Replied' | translate }}
									</button>
								</li>
								<li>
									<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.FollowUp, $event.target.innerText)">
										{{ 'Event_QA_FollowUp' | translate }}
									</button>
								</li>
								<li>
									<button type="button" class="dropdown-item" (click)="filterClosedQuestions(QuestionAction.Closed, $event.target.innerText)">
										{{ 'Event_QA_Closed' | translate }}
									</button>
								</li>
							</ul>
						</div>
						<div>
							<button type="button" [attr.aria-label]="('Remove'  | translate ) + ' ' + ('Event_QA_List_Closed'  | translate)" class="btn-hide-question-list" (click)="isClosedHidden = !isClosedHidden"><span class="glyphicons remove_2"></span></button>
						</div>
					</div>
				</header>

				<vb-webcast-questions-list [context]="context" [webcast]="webcast" [questions]="closedQuestions">
				</vb-webcast-questions-list>
			</section>
		</main>

		<!--Webcast Status Messages-->
		<div class="webcast-presentation-msg-container theme-primary" [hidden]="!webcast.currentRun.isEnded">
			<div class="ppt-loading-wrapper">
				<h3>{{ 'Event_EventHasEnded' | translate }}</h3>
			</div>
		</div>
	</div>
}
